import React, { useState, useCallback } from 'react';
import { useAddin } from '../App';
import TabBar from '../components/TabBar';
import MatterCard from '../components/MatterCard';
import ActionButton, { icons } from '../components/ActionButton';
import ActionsTab from '../tabs/ActionsTab';
import MatterTab from '../tabs/MatterTab';
import TasksTab from '../tabs/TasksTab';
import DocumentsTab from '../tabs/DocumentsTab';
import HistoryTab from '../tabs/HistoryTab';
import InboxTab from '../tabs/InboxTab';

const TABS = ['Actions', 'Matter', 'Tasks', 'Documents', 'History', 'Inbox'];

/**
 * Reading Pane panel — shown when viewing an email.
 * Contains 4 tabs: Actions, Matter, Documents, History.
 */
export default function ReadingPane() {
    const [activeTab, setActiveTab] = useState('Actions');

    const renderTab = () => {
        switch (activeTab) {
            case 'Actions':
                return <ActionsTab />;
            case 'Matter':
                return <MatterTab />;
            case 'Tasks':
                return <TasksTab />;
            case 'Documents':
                return <DocumentsTab />;
            case 'History':
                return <HistoryTab />;
            case 'Inbox':
                return <InboxTab />;
            default:
                return null;
        }
    };

    return (
        <>
            <TabBar tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} />
            {renderTab()}
        </>
    );
}
